import React from "react";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";

export function BloomreachChoiceDialog({ isOpen, onOpenChange, onChoice, isLoading }) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="520px">
        <Dialog.Title>Previous Bloomreach connection found</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Resume from the previous sync cursors, or continue from now and only push new
          guests going forward.
        </Dialog.Description>
        <Flex justify="end" gap="3">
          <Button
            variant="soft"
            color="gray"
            disabled={isLoading}
            onClick={() => onChoice("continue_from_now")}
          >
            Continue from now
          </Button>
          <Button
            variant="soft"
            color="accent"
            loading={isLoading}
            onClick={() => onChoice("resume")}
          >
            Resume previous sync
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
